export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer__flex">
          <span>&copy; {new Date().getFullYear()} Cedrick Caceres</span>
        </div>
      </footer>
    </>
  );
}
